export const EMBED_SYSTEM_TAGS = ['embed', 'scribane: embed'] as const;
export const SYSTEM_TAGS = [
  ...EMBED_SYSTEM_TAGS,
  'scribane: note',
  'scribane: import',
] as const;

export function isSystemTag(tag: string): boolean {
  return (SYSTEM_TAGS as readonly string[]).includes(tag.trim().toLowerCase());
}

export function isEmbedSystemTag(tag: string): boolean {
  return (EMBED_SYSTEM_TAGS as readonly string[]).includes(tag.trim().toLowerCase());
}
